import { TRANSITION_DURATION } from '@constants/common'
import type { StepForm } from '@types'
import { useEffect, useRef } from 'react'

export function useScrollToNewQuestion(questions: StepForm) {
  const questionRefs = useRef<{ [key: string]: any }>({})
  const prevFieldNamesRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const prevFieldNames = prevFieldNamesRef.current

    if (prevFieldNames.size) {
      const newQuestions = questions.filter((q) => !prevFieldNames.has(q.db_field_name))

      if (newQuestions.length) {
        setTimeout(() => {
          questionRefs.current[newQuestions[0].db_field_name]?.scrollIntoView({ behavior: 'smooth' })
        }, TRANSITION_DURATION * 1000)
      }
    }

    prevFieldNamesRef.current = new Set(questions.map((q) => q.db_field_name))
  }, [questions])

  return questionRefs
}
